module.exports = __webpack_public_path__ + "static/media/6-9.3b59e3b1.webp";